import moment from 'moment'
import React from 'react'

import { EuiTitle, EuiSpacer, EuiText, EuiFlexItem, EuiFlexGroup } from '@elastic/eui'

import { MasterCampaignPlanCampaignBuilder } from 'api/interfaces/MasterCampaignStub'
import GanttChart from 'features/planner/components/GanttChart/GanttChart'
import BackgroundContentCard from 'features/planner/pages/MasterCampaignPlanPage/components/BackgroundContentCard'

export interface CampaignTimelineProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  planStartDate: moment.Moment
  planDurationMonths: number
  isLoading?: boolean
  ganttChartRef?: React.RefObject<HTMLDivElement>
  isClickable?: boolean
  isHoverable?: boolean
}

const CampaignTimeline: React.FC<CampaignTimelineProps> = ({ campaigns, planStartDate, planDurationMonths, isLoading = false, ganttChartRef, isClickable = false, isHoverable = false }) => {
  return (
    <BackgroundContentCard>
      <EuiFlexGroup>
        <EuiFlexItem />
        <EuiFlexItem style={{ textAlign: 'center' }}>
          <EuiTitle size='s'>
            <h4>Campaign Timeline</h4>
          </EuiTitle>
        </EuiFlexItem>
        <EuiFlexItem />
      </EuiFlexGroup>

      <EuiSpacer size='m' />

      {isLoading ? (
        <EuiText>
          <p>Loading campaign data...</p>
        </EuiText>
      ) : (
        <GanttChart campaigns={campaigns} planStartDate={planStartDate} planDurationMonths={planDurationMonths} ganttChartRef={ganttChartRef} isClickable={isClickable} isHoverable={isHoverable} />
      )}
    </BackgroundContentCard>
  )
}

export default CampaignTimeline
